import React, {useContext, useRef } from "react";
import { PJContext } from "./pj-context"
import {supFractions} from "../helpers";
import CONSTS from "./pj-constants";
import { PJJourneyNav } from "./pj-journey-nav"



function PJOrderReview(props) {
    const { state, dispatch, data, animateFromCheckout } = useContext(PJContext);
    const containerRef = useRef(); //Container dom reference for animations

    return  (
        <div className={"order-frame journey-step order-review step-2 " + props.current} ref={containerRef}>
            <div className="frame-content d-flex">
                <div className="order-review my-auto mx-auto">
                    <h4 className="center">YOUR <strong>REV</strong> ORDER</h4>
                    <div className="line-item mx-auto d-flex head-cell">
                        <h2 className="flex-fill" dangerouslySetInnerHTML={{__html: data.title}} />
                        <div className="order-total line-cost mt-auto" dangerouslySetInnerHTML={{__html: supFractions(state.totalPrice)}} />
                    </div>
                    {(data.type === 'customBundle') &&
                    <div>
                        {data.included.map((included, i) => {
                            return (
                                <div className="line-item mx-auto d-flex" key={included.id}>
                                    <div className="flex-fill" dangerouslySetInnerHTML={{__html: included.title}} />
                                </div>
                            );
                        })}
                        <br />
                    </div>
                    }
                    {Object.keys(state.selectedAddons).map((addonKey, i) => {
                        return (
                            <div className="line-item mx-auto d-flex" key={state.selectedAddons[addonKey].id}>
                                <div className="title flex-fill" dangerouslySetInnerHTML={{__html: state.selectedAddons[addonKey].title}} />
                                <div className="line-cost" dangerouslySetInnerHTML={{__html: supFractions(state.selectedAddons[addonKey].price)}} />
                            </div>
                        );
                    })}
                    {Object.keys(state.standaloneSelected).map((addonKey, i) => {
                        return (
                            <div className="line-item mx-auto d-flex" key={state.standaloneSelected[addonKey].id}>
                                <div className="title flex-fill" dangerouslySetInnerHTML={{__html: state.standaloneSelected[addonKey].title}} />
                                <div className="line-cost" dangerouslySetInnerHTML={{__html: supFractions(state.standaloneSelected[addonKey].price)}} />
                            </div>
                        );
                    })}
                    {state.seasonTickets &&
                        <div className="line-item mx-auto d-flex">
                            <div className="title flex-fill">Find out more about season tickets</div>
                            <div className="line-cost">Yes</div>
                        </div>
                    }
                    <hr className="line-item mx-auto" />
                    <div className={"line-item mx-auto monthly-total d-flex " + ((state.seasonTotal > 0) && 'has-season-cost')}>
                        <div className="title flex-fill mt-auto">monthly cost</div>
                        <div className="line-cost" dangerouslySetInnerHTML={{__html: supFractions(state.monthlyTotal)}} />
                    </div>
                    {(state.seasonTotal > 0) &&
                        <>
                            <div className="line-item mx-auto monthly-total d-flex">
                                <div className="title flex-fill mt-auto">+ season cost</div>
                                <div className="line-cost" dangerouslySetInnerHTML={{__html: supFractions(state.seasonTotal)}} />
                            </div>
                        </>
                    }

                    <div className="disclaimer small-font center">
                        Installation fees and deposits apply for new customers<br />
                        <p className="small">* prices exclude VAT</p>
                    </div>
                </div>
            </div>

            <PJJourneyNav
                backClick={e => animateFromCheckout()}
                continueClick={e => dispatch({ type: CONSTS.SET_STEP, args: {step: CONSTS.STEP_3_EXISTING_CUSTOMER} })}
                containerRef={containerRef}
            />
        </div>
    );
}

export { PJOrderReview };